export default __webpack_public_path__ + "static/media/04.453cad04.png";